// extracted by mini-css-extract-plugin
module.exports = {"container":"upload_container__2OFJQ","upload":"upload_upload__b56Hp","visualBox":"upload_visualBox__3dJbw"};